import React from "react";
import { DocumentIcon } from "@heroicons/react/24/outline";
import { PageI } from "../../../types";

interface PagesTabContentProps {
  pages: PageI[];
  selectedPageId: string | null;
  onSelectPage: (page: PageI) => void;
}

const PagesTabContent: React.FC<PagesTabContentProps> = ({
  pages,
  selectedPageId,
  onSelectPage,
}) => {
  if (pages.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">No unlinked pages</div>
    );
  }

  return (
    <div className="divide-y">
      {pages.map((page: PageI) => (
        <div
          key={page._id}
          className={`p-4 cursor-pointer hover:bg-gray-50 transition-colors ${
            selectedPageId === page._id
              ? "bg-blue-50 border-l-4 border-blue-500"
              : ""
          }`}
          onClick={() => onSelectPage(page)}
        >
          <div className="flex items-center gap-3">
            <DocumentIcon className="w-8 h-8 text-gray-400" />
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm truncate">
                {page.title || "Untitled Page"}
              </p>
              <p className="text-xs text-gray-500">
                {page.components?.length || 0} components
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PagesTabContent;
